import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { useCallback, useEffect, useMemo, useState } from "react";
import { Spacings, View } from "react-native-ui-lib";
import { Button, Page } from "@towersystems/roam-common-native";
import { ReceiptModalRootParmList } from "../../../../types";
import { TextButton } from "@towersystems/roam-common-native";
import { TextField } from "@towersystems/roam-common-native";
import { Sale } from "@towersystems/roam-common/lib/generated-types";
import { useHasTransitionEnded } from "../../../../utilities/use-after-interactions";
import { useEmailReceipt } from "../../../../utilities/receipt";
import { useFlashMessages } from "@towersystems/roam-common-native";
import { useSaleContextProvider } from "../../utils";
import { useTranslation } from "../../../../utilities/i18n/client";

export type EmailReceiptModalScreenProps = NativeStackScreenProps<
  ReceiptModalRootParmList,
  "EmailReceiptModalScreen"
> & {};

export const EmailReceiptModalScreen = ({
  navigation,
  route,
}: EmailReceiptModalScreenProps) => {
  const { t } = useTranslation("sales");
  const { sale } = useSaleContextProvider();
  const shouldFocus = useHasTransitionEnded(navigation);
  const { emailReceipt } = useEmailReceipt();
  const { showMessage } = useFlashMessages();
  const { templateId } = route.params;

  const [emailAddressInput, setEmailAddressInput] = useState(
    sale.customer?.emailAddress || ""
  );

  const isValid = useMemo(() => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(emailAddressInput);
  }, [emailAddressInput]);

  const handleOnSend = useCallback(
    async (sale: Sale) => {
      try {
        await emailReceipt(sale.id, emailAddressInput, templateId);
        showMessage({
          message: t("common:action_success"),
          severity: "success",
        });
        navigation.getParent()?.goBack();
      } catch (err) {
        showMessage({
          message: t("common:action_fail"),
          severity: "error",
        });
      }
    },
    [emailAddressInput, templateId]
  );

  useEffect(() => {
    navigation.setOptions({
      headerRight: () => (
        <View style={{ paddingRight: Spacings.s4 }}>
          <Button
            isAction
            size="compact"
            disabled={!isValid}
            onPress={() => handleOnSend(sale)}
            label="Send"
          ></Button>
        </View>
      ),
    });
  }, [isValid, handleOnSend]);

  const handleOnChangeText = useCallback(
    (t: string) => {
      setEmailAddressInput(t);
    },
    [setEmailAddressInput]
  );

  return (
    <Page>
      <View>
        <TextField
          placeholder={t("form.email.placeholder")}
          validate={["required", "email"]}
          value={emailAddressInput}
          onChangeText={handleOnChangeText}
          autoFocus={shouldFocus}
        />
      </View>
    </Page>
  );
};
